import { LAYER_LEGENDS } from "../config/legend";
import type { DeforestationLayerStates } from "../types/deforestation";

interface LegendPanelProps {
  layers: DeforestationLayerStates;
}

export function LegendPanel({ layers }: LegendPanelProps) {
  // Dedupe by legend title — Forest 2020 and Forest 2025 share the
  // crown-cover palette, so showing both side-by-side is just noise.
  const seenTitles = new Set<string>();
  const active = (
    Object.keys(LAYER_LEGENDS) as Array<keyof DeforestationLayerStates>
  ).filter((key) => {
    if (!layers[key]?.visible) return false;
    const title = LAYER_LEGENDS[key]?.title;
    if (!title || seenTitles.has(title)) return false;
    seenTitles.add(title);
    return true;
  });

  if (active.length === 0) return null;

  return (
    <div className="border-t bg-card/95 p-3">
      <h3 className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
        Legend
      </h3>
      <div className="space-y-2">
        {active.map((key) => {
          const legend = LAYER_LEGENDS[key];
          if (!legend) return null;
          return (
            <div key={key}>
              <p className="mb-1 text-xs font-medium">{legend.title}</p>
              <div className="grid grid-cols-2 gap-x-2 gap-y-0.5">
                {legend.entries.map((entry) => (
                  <div
                    key={entry.label}
                    className="flex items-center gap-1.5 text-xs text-muted-foreground"
                  >
                    <span
                      aria-hidden
                      className="h-3 w-3 shrink-0 rounded-full border border-border"
                      style={{ backgroundColor: entry.color }}
                    />
                    <span className="truncate">{entry.label}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
